import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';

export function waitForAuthUser(timeoutMs = 8000) {
  if (auth.currentUser) {
    return Promise.resolve(auth.currentUser);
  }

  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      unsubscribe();
      reject(new Error('User not authenticated. Please sign in again.'));
    }, timeoutMs);

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        clearTimeout(timer);
        unsubscribe();
        resolve(user);
      }
    });
  });
}

/** Headers for API calls through Firebase Hosting → Cloud Run (see adminApiAuth.js in main app). */
export async function getFirebaseAuthHeaders(forceRefresh = true) {
  const user = auth.currentUser || (await waitForAuthUser());
  const idToken = await user.getIdToken(forceRefresh);

  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${idToken}`,
    'X-Firebase-Token': idToken,
  };
}
